import ProductService from '_services/rest/modules/product';

export default {
  state: {
    product: null,
    productList: null,
  },
  mutations: {
    setProduct(state, response) {
      state.product = response;
    },
    setProductList(state, response) {
      state.productList = response;
    },
  },
  actions: {
    getProductList({ commit }, params) {
      return ProductService.getList(params)
        .then(response => {
          commit('setProductList', response);
        });
    },
    getProduct({ commit }, params) {
      return ProductService.getProductById(params)
        .then(response => {
          commit('setProduct', response);
        });
    },
    setProduct({ commit }, params) {
      commit('setProduct', params);
    },
  },
};
